// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__KEpvN","rootCenter":"LoadMoreObserver_rootCenter__kD69M","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1QcN_"};